const LOGO_SRC = "/konddo-logo.png";

export const KMark = ({ size = 40, className = "" }) => (
  <img
    data-testid="k-mark"
    src={LOGO_SRC}
    alt="KONDDO"
    className={`object-contain shrink-0 ${className}`}
    style={{ width: size, height: size, filter: "drop-shadow(0 0 12px rgba(176,38,255,0.45))" }}
  />
);

export const KWordmark = ({ size = 40, className = "", withMark = true, tagline = false }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    {withMark && <KMark size={size} />}
    <div className="flex flex-col">
      <span
        className="font-display font-extrabold tracking-[0.28em] brand-text leading-none"
        style={{ fontSize: size * 0.5 }}
      >
        KONDDO
      </span>
      {tagline && (
        <span className="text-[10px] text-muted-foreground tracking-wider mt-1">
          Seu condomínio acontece aqui.
        </span>
      )}
    </div>
  </div>
);
